export const emoji = {
  people: [
    '😀',
    '😬',
    '😁',
    '😂',
    '😃',
    '😄',
    '😅',
    '😆',
    '😇',
    '😉',
    '😊',
    '🙂',
    '🙃',
    '☺️',
    '😋',
    '😌',
    '😍',
    '😘',
    '😗',
    '😙',
    '😚',
    '😜',
    '😝',
    '😛',
    '🤑',
    '🤓',
    '😎',
    '🤗',
    '😏',
    '😶',
    '😐',
    '😑',
    '😒',
    '🙄',
    '🤔',
    '😳',
    '😞',
    '😟',
    '😠',
    '😡',
    '😔',
    '😕',
    '🙁',
    '☹️',
    '😣',
    '😖',
    '😫',
    '😩',
    '😤',
    '😮',
    '😱',
    '😨',
    '😰',
    '😯',
    '😦',
    '😧',
    '😢',
    '😥',
    '😪',
    '😓',
    '😭',
    '😵',
    '😲',
    '🤐',
    '😷',
    '🤒',
    '🤕',
    '😴',
    '💤',
    '💩',
    '😈',
    '👿',
    '👹',
    '👺',
    '💀',
    '👻',
    '👽',
    '🤖',
    '😺',
    '😸',
    '😹',
    '😻',
    '😼',
    '😽',
    '🙀',
    '😿',
    '😾',
    '🙌',
    '👏',
    '👋',
    '👍',
    '👊',
    '✊',
    '✌️',
    '👌',
    '✋',
    '💪',
    '🙏',
    '☝️',
    '👆',
    '👇',
    '👈',
    '👉',
    '🖕',
    '🤘',
    '🖖',
    '✍️',
    '💅',
    '👄',
    '👅',
    '👂',
    '👃',
    '👁',
    '👀',
    '👤',
    '🗣',
    '👶',
    '👦',
    '👧',
    '👨',
    '👩',
    '👱',
    '👴',
    '👵',
    '👲',
    '👳',
    '👮',
    '👷',
    '💂',
    '🕵',
    '🎅',
    '👼',
    '👸',
    '👰',
    '🚶',
    '🏃',
    '💃',
    '👯',
    '👫',
    '👬',
    '👭',
    '🙇',
    '💁',
    '🙅',
    '🙆',
    '🙋',
    '🙎',
    '🙍',
    '💇',
    '💆',
    '💑',
    '👩‍❤️‍👩',
    '👨‍❤️‍👨',
    '💏',
    '👩‍❤️‍💋‍👩',
    '👨‍❤️‍💋‍👨',
    '👪',
    '👨‍👩‍👧',
    '👨‍👩‍👧‍👦',
    '👨‍👩‍👦‍👦',
    '👨‍👩‍👧‍👧',
    '👩‍👩‍👦',
    '👩‍👩‍👧',
    '👩‍👩‍👧‍👦',
    '👩‍👩‍👦‍👦',
    '👩‍👩‍👧‍👧',
    '👨‍👨‍👦',
    '👨‍👨‍👧',
    '👨‍👨‍👧‍👦',
    '👨‍👨‍👦‍👦',
    '👨‍👨‍👧‍👧',
    '👚',
    '👕',
    '👖',
    '👔',
    '👗',
    '👙',
    '👘',
    '💄',
    '💋',
    '👣',
    '👠',
    '👡',
    '👢',
    '👞',
    '👟',
    '👒',
    '🎩',
    '⛑',
    '🎓',
    '👑',
    '🎒',
    '👝',
    '👛',
    '👜',
    '💼',
    '👓',
    '🕶',
    '💍',
    '🌂',
  ],
  nature: [
    '🐶',
    '🐱',
    '🐭',
    '🐹',
    '🐰',
    '🐻',
    '🐼',
    '🐨',
    '🐯',
    '🦁',
    '🐮',
    '🐷',
    '🐽',
    '🐸',
    '🐙',
    '🐵',
    '🙈',
    '🙉',
    '🙊',
    '🐒',
    '🐔',
    '🐧',
    '🐦',
    '🐤',
    '🐣',
    '🐥',
    '🐺',
    '🐗',
    '🐴',
    '🦄',
    '🐝',
    '🐛',
    '🐌',
    '🐞',
    '🐜',
    '🕷',
    '🦂',
    '🦀',
    '🐍',
    '🐢',
    '🐠',
    '🐟',
    '🐡',
    '🐬',
    '🐳',
    '🐋',
    '🐊',
    '🐆',
    '🐅',
    '🐃',
    '🐂',
    '🐄',
    '🐪',
    '🐫',
    '🐘',
    '🐐',
    '🐏',
    '🐑',
    '🐎',
    '🐖',
    '🐀',
    '🐁',
    '🐓',
    '🦃',
    '🕊',
    '🐕',
    '🐩',
    '🐈',
    '🐇',
    '🐿',
    '🐾',
    '🐉',
    '🐲',
    '🌵',
    '🎄',
    '🌲',
    '🌳',
    '🌴',
    '🌱',
    '🌿',
    '☘',
    '🍀',
    '🎍',
    '🎋',
    '🍃',
    '🍂',
    '🍁',
    '🌾',
    '🌺',
    '🌻',
    '🌹',
    '🌷',
    '🌼',
    '🌸',
    '💐',
    '🍄',
    '🌰',
    '🎃',
    '🐚',
    '🕸',
    '🌎',
    '🌍',
    '🌏',
    '🌕',
    '🌖',
    '🌗',
    '🌘',
    '🌑',
    '🌒',
    '🌓',
    '🌔',
    '🌚',
    '🌝',
    '🌛',
    '🌜',
    '🌞',
    '🌙',
    '⭐️',
    '🌟',
    '💫',
    '✨',
    '☄',
    '☀️',
    '🌤',
    '⛅️',
    '🌥',
    '🌦',
    '☁️',
    '🌧',
    '⛈',
    '🌩',
    '⚡️',
    '🔥',
    '💥',
    '❄️',
    '🌨',
    '🔥',
    '💥',
    '❄️',
    '🌨',
    '☃️',
    '⛄️',
    '🌬',
    '💨',
    '🌪',
    '🌫',
    '☂️',
    '☔️',
    '💧',
    '💦',
    '🌊',
  ],
  'food-and-drink': [
    '🍏',
    '🍎',
    '🍐',
    '🍊',
    '🍋',
    '🍌',
    '🍉',
    '🍇',
    '🍓',
    '🍈',
    '🍒',
    '🍑',
    '🍍',
    '🍅',
    '🍆',
    '🌶',
    '🌽',
    '🍠',
    '🍯',
    '🍞',
    '🧀',
    '🍗',
    '🍖',
    '🍤',
    '🍳',
    '🍔',
    '🍟',
    '🌭',
    '🍕',
    '🍝',
    '🌮',
    '🌯',
    '🍜',
    '🍲',
    '🍥',
    '🍣',
    '🍱',
    '🍛',
    '🍙',
    '🍚',
    '🍘',
    '🍢',
    '🍡',
    '🍧',
    '🍨',
    '🍦',
    '🍰',
    '🎂',
    '🍮',
    '🍬',
    '🍭',
    '🍫',
    '🍿',
    '🍩',
    '🍪',
    '🍺',
    '🍻',
    '🍷',
    '🍸',
    '🍹',
    '🍾',
    '🍶',
    '🍵',
    '☕️',
    '🍼',
    '🍴',
    '🍽',
  ],
  activity: [
    '⚽️',
    '🏀',
    '🏈',
    '⚾️',
    '🎾',
    '🏐',
    '🏉',
    '🎱',
    '⛳️',
    '🏌',
    '🏓',
    '🏸',
    '🏒',
    '🏑',
    '🏏',
    '🎿',
    '⛷',
    '🏂',
    '⛸',
    '🏹',
    '🎣',
    '🚣',
    '🏊',
    '🏄',
    '🛀',
    '⛹',
    '🏋',
    '🚴',
    '🚵',
    '🏇',
    '🕴',
    '🏆',
    '🎽',
    '🏅',
    '🎖',
    '🎗',
    '🏵',
    '🎫',
    '🎟',
    '🎭',
    '🎨',
    '🎪',
    '🎤',
    '🎧',
    '🎼',
    '🎹',
    '🎷',
    '🎺',
    '🎸',
    '🎻',
    '🎬',
    '🎮',
    '👾',
    '🎯',
    '🎲',
    '🎰',
    '🎳',
  ],
  'travel-and-places': [
    '🚗',
    '🚕',
    '🚙',
    '🚌',
    '🚎',
    '🏎',
    '🚓',
    '🚑',
    '🚒',
    '🚐',
    '🚚',
    '🚛',
    '🚜',
    '🏍',
    '🚲',
    '🚨',
    '🚔',
    '🚍',
    '🚘',
    '🚖',
    '🚡',
    '🚠',
    '🚟',
    '🚃',
    '🚋',
    '🚝',
    '🚄',
    '🚅',
    '🚈',
    '🚞',
    '🚂',
    '🚆',
    '🚇',
    '🚊',
    '🚉',
    '🚁',
    '🛩',
    '✈️',
    '🛫',
    '🛬',
    '⛵️',
    '🛥',
    '🚤',
    '⛴',
    '🛳',
    '🚀',
    '🛰',
    '💺',
    '⚓️',
    '🚧',
    '⛽️',
    '🚏',
    '🚦',
    '🚥',
    '🏁',
    '🚢',
    '🎡',
    '🎢',
    '🎠',
    '🏗',
    '🌁',
    '🗼',
    '🏭',
    '⛲️',
    '🎑',
    '⛰',
    '🏔',
    '🗻',
    '🌋',
    '🗾',
    '🏕',
    '⛺️',
    '🏞',
    '🛣',
    '🛤',
    '🌅',
    '🌄',
    '🏜',
    '🏖',
    '🏝',
    '🌇',
    '🌆',
    '🏙',
    '🌃',
    '🌉',
    '🌌',
    '🌠',
    '🎇',
    '🎆',
    '🌈',
    '🏘',
    '🏰',
    '🏯',
    '🏟',
    '🗽',
    '🏠',
    '🏡',
    '🏚',
    '🏢',
    '🏬',
    '🏣',
    '🏤',
    '🏥',
    '🏦',
    '🏨',
    '🏪',
    '🏫',
    '🏩',
    '💒',
    '🏛',
    '⛪️',
    '🕌',
    '🕍',
    '🕋',
    '⛩',
  ],
  objects: [
    '⌚️',
    '📱',
    '📲',
    '💻',
    '⌨',
    '🖥',
    '🖨',
    '🖱',
    '🖲',
    '🕹',
    '🗜',
    '💽',
    '💾',
    '💿',
    '📀',
    '📼',
    '📷',
    '📸',
    '📹',
    '🎥',
    '📽',
    '🎞',
    '📞',
    '☎️',
    '📟',
    '📠',
    '📺',
    '📻',
    '🎙',
    '🎚',
    '🎛',
    '⏱',
    '⏲',
    '⏰',
    '🕰',
    '⏳',
    '⌛️',
    '📡',
    '🔋',
    '🔌',
    '💡',
    '🔦',
    '🕯',
    '🗑',
    '🛢',
    '💸',
    '💵',
    '💴',
    '💶',
    '💷',
    '💰',
    '💳',
    '💎',
    '⚖',
    '🔧',
    '🔨',
    '⚒',
    '🛠',
    '⛏',
    '🔩',
    '⚙',
    '⛓',
    '🔫',
    '💣',
    '🔪',
    '🗡',
    '⚔',
    '🛡',
    '🚬',
    '☠',
    '⚰',
    '⚱',
    '🏺',
    '🔮',
    '📿',
    '💈',
    '⚗',
    '🔭',
    '🔬',
    '🕳',
    '💊',
    '💉',
    '🌡',
    '🏷',
    '🔖',
    '🚽',
    '🚿',
    '🛁',
    '🔑',
    '🗝',
    '🛋',
    '🛌',
    '🛏',
    '🚪',
    '🛎',
    '🖼',
    '🗺',
    '⛱',
    '🗿',
    '🛍',
    '🎈',
    '🎏',
    '🎀',
    '🎁',
    '🎊',
    '🎉',
    '🎎',
    '🎐',
    '🎌',
    '🏮',
    '✉️',
    '📩',
    '📨',
    '📧',
    '💌',
    '📮',
    '📪',
    '📫',
    '📬',
    '📭',
    '📦',
    '📯',
    '📥',
    '📤',
    '📜',
    '📃',
    '📑',
    '📊',
    '📈',
    '📉',
    '📄',
    '📅',
    '📆',
    '🗓',
    '📇',
    '🗃',
    '🗳',
    '🗄',
    '📋',
    '🗒',
    '📁',
    '📂',
    '🗂',
    '🗞',
    '📰',
    '📓',
    '📕',
    '📗',
    '📘',
    '📙',
    '📔',
    '📒',
    '📚',
    '📖',
    '🔗',
    '📎',
    '🖇',
    '✂️',
    '📐',
    '📏',
    '📌',
    '📍',
    '🚩',
    '🏳',
    '🏴',
    '🔐',
    '🔒',
    '🔓',
    '🔏',
    '🖊',
    '🖊',
    '🖋',
    '✒️',
    '📝',
    '✏️',
    '🖍',
    '🖌',
    '🔍',
    '🔎',
  ],
  symbols: [
    '❤️',
    '💛',
    '💙',
    '💜',
    '💔',
    '❣️',
    '💕',
    '💞',
    '💓',
    '💗',
    '💖',
    '💘',
    '💝',
    '💟',
    '☮',
    '✝️',
    '☪',
    '🕉',
    '☸',
    '✡️',
    '🔯',
    '🕎',
    '☯️',
    '☦',
    '🛐',
    '⛎',
    '♈️',
    '♉️',
    '♊️',
    '♋️',
    '♌️',
    '♍️',
    '♎️',
    '♏️',
    '♐️',
    '♑️',
    '♒️',
    '♓️',
    '🆔',
    '⚛',
    '🈳',
    '🈹',
    '☢',
    '☣',
    '📴',
    '📳',
    '🈶',
    '🈚️',
    '🈸',
    '🈺',
    '🈷️',
    '✴️',
    '🆚',
    '🉑',
    '💮',
    '🉐',
    '㊙️',
    '㊗️',
    '🈴',
    '🈵',
    '🈲',
    '🅰️',
    '🅱️',
    '🆎',
    '🆑',
    '🅾️',
    '🆘',
    '⛔️',
    '📛',
    '🚫',
    '❌',
    '⭕️',
    '💢',
    '♨️',
    '🚷',
    '🚯',
    '🚳',
    '🚱',
    '🔞',
    '📵',
    '❗️',
    '❕',
    '❓',
    '❔',
    '‼️',
    '⁉️',
    '💯',
    '🔅',
    '🔆',
    '🔱',
    '⚜',
    '〽️',
    '⚠️',
    '🚸',
    '🔰',
    '♻️',
    '🈯️',
    '💹',
    '❇️',
    '✳️',
    '❎',
    '✅',
    '💠',
    '🌀',
    '➿',
    '🌐',
    'Ⓜ️',
    '🏧',
    '🈂️',
    '🛂',
    '🛃',
    '🛄',
    '🛅',
    '♿️',
    '🚭',
    '🚾',
    '🅿️',
    '🚰',
    '🚹',
    '🚺',
    '🚼',
    '🚻',
    '🚮',
    '🎦',
    '📶',
    '🈁',
    '🆖',
    '🆗',
    '🆙',
    '🆒',
    '🆕',
    '🆓',
    '0️⃣',
    '1️⃣',
    '2️⃣',
    '3️⃣',
    '4️⃣',
    '5️⃣',
    '6️⃣',
    '7️⃣',
    '8️⃣',
    '9️⃣',
    '🔟',
    '🔢',
    '▶️',
    '⏸',
    '⏯',
    '⏹',
    '⏺',
    '⏭',
    '⏮',
    '⏩',
    '⏪',
    '🔀',
    '🔁',
    '🔂',
    '◀️',
    '🔼',
    '🔽',
    '⏫',
    '⏬',
    '➡️',
    '⬅️',
    '⬆️',
    '⬇️',
    '↗️',
    '↘️',
    '↙️',
    '↖️',
    '↕️',
    '↔️',
    '🔄',
    '↪️',
    '↩️',
    '⤴️',
    '⤵️',
    '#️⃣',
    '*️⃣',
    'ℹ️',
    '🔤',
    '🔡',
    '🔠',
    '🔣',
    '🎵',
    '🎶',
    '〰️',
    '➰',
    '✔️',
    '🔃',
    '➕',
    '➖',
    '➗',
    '✖️',
    '💲',
    '💱',
    '©️',
    '®️',
    '™️',
    '🔚',
    '🔙',
    '🔛',
    '🔝',
    '🔜',
    '☑️',
    '🔘',
    '⚪️',
    '⚫️',
    '🔴',
    '🔵',
    '🔸',
    '🔹',
    '🔶',
    '🔷',
    '🔺',
    '▪️',
    '▫️',
    '⬛️',
    '⬜️',
    '🔻',
    '◼️',
    '◻️',
    '◾️',
    '◽️',
    '🔲',
    '🔳',
    '🔈',
    '🔉',
    '🔊',
    '🔇',
    '📣',
    '📢',
    '🔔',
    '🔕',
    '🃏',
    '🀄️',
    '♠️',
    '♣️',
    '♥️',
    '♦️',
    '🎴',
    '👁‍🗨',
    '💭',
    '🗯',
    '💬',
    '🕐',
    '🕑',
    '🕒',
    '🕓',
    '🕔',
    '🕕',
    '🕖',
    '🕗',
    '🕘',
    '🕙',
    '🕚',
    '🕛',
    '🕜',
    '🕝',
    '🕞',
    '🕟',
    '🕠',
    '🕡',
    '🕢',
    '🕣',
    '🕤',
    '🕥',
    '🕦',
    '🕧',
  ],
  flags: [
    '🇦🇫',
    '🇦🇽',
    '🇦🇱',
    '🇩🇿',
    '🇦🇸',
    '🇦🇩',
    '🇦🇴',
    '🇦🇮',
    '🇦🇶',
    '🇦🇬',
    '🇦🇷',
    '🇦🇲',
    '🇦🇼',
    '🇦🇺',
    '🇦🇹',
    '🇦🇿',
    '🇧🇸',
    '🇧🇭',
    '🇧🇩',
    '🇧🇧',
    '🇧🇾',
    '🇧🇪',
    '🇧🇿',
    '🇧🇯',
    '🇧🇲',
    '🇧🇹',
    '🇧🇴',
    '🇧🇶',
    '🇧🇦',
    '🇧🇼',
    '🇧🇷',
    '🇮🇴',
    '🇻🇬',
    '🇧🇳',
    '🇧🇬',
    '🇧🇫',
    '🇧🇮',
    '🇨🇻',
    '🇰🇭',
    '🇨🇲',
    '🇨🇦',
    '🇮🇨',
    '🇰🇾',
    '🇨🇫',
    '🇹🇩',
    '🇨🇱',
    '🇨🇳',
    '🇨🇽',
    '🇨🇨',
    '🇨🇴',
    '🇰🇲',
    '🇨🇬',
    '🇨🇩',
    '🇨🇰',
    '🇨🇷',
    '🇭🇷',
    '🇨🇺',
    '🇨🇼',
    '🇨🇾',
    '🇨🇿',
    '🇩🇰',
    '🇩🇯',
    '🇩🇲',
    '🇩🇴',
    '🇪🇨',
    '🇪🇬',
    '🇸🇻',
    '🇬🇶',
    '🇪🇷',
    '🇪🇪',
    '🇪🇹',
    '🇪🇺',
    '🇫🇰',
    '🇫🇴',
    '🇫🇯',
    '🇫🇮',
    '🇫🇷',
    '🇬🇫',
    '🇵🇫',
    '🇹🇫',
    '🇬🇦',
    '🇬🇲',
    '🇬🇪',
    '🇩🇪',
    '🇬🇭',
    '🇬🇮',
    '🇬🇷',
    '🇬🇱',
    '🇬🇩',
    '🇬🇵',
    '🇬🇺',
    '🇬🇹',
    '🇬🇬',
    '🇬🇳',
    '🇬🇼',
    '🇬🇾',
    '🇭🇹',
    '🇭🇳',
    '🇭🇰',
    '🇭🇺',
    '🇮🇸',
    '🇮🇳',
    '🇮🇩',
    '🇮🇷',
    '🇮🇶',
    '🇮🇪',
    '🇮🇲',
    '🇮🇱',
    '🇮🇹',
    '🇨🇮',
    '🇯🇲',
    '🇯🇵',
    '🇯🇪',
    '🇯🇴',
    '🇰🇿',
    '🇰🇪',
    '🇰🇮',
    '🇽🇰',
    '🇰🇼',
    '🇰🇬',
    '🇱🇦',
    '🇱🇻',
    '🇱🇧',
    '🇱🇸',
    '🇱🇷',
    '🇱🇾',
    '🇱🇮',
    '🇱🇹',
    '🇱🇺',
    '🇲🇴',
    '🇲🇰',
    '🇲🇬',
    '🇲🇼',
    '🇲🇾',
    '🇲🇻',
    '🇲🇱',
    '🇲🇹',
    '🇲🇭',
    '🇲🇶',
    '🇲🇷',
    '🇲🇺',
    '🇾🇹',
    '🇲🇽',
    '🇫🇲',
    '🇲🇩',
    '🇲🇨',
    '🇲🇳',
    '🇲🇪',
    '🇲🇸',
    '🇲🇦',
    '🇲🇿',
    '🇲🇲',
    '🇳🇦',
    '🇳🇷',
    '🇳🇵',
    '🇳🇱',
    '🇳🇨',
    '🇳🇿',
    '🇳🇮',
    '🇳🇪',
    '🇳🇬',
    '🇳🇺',
    '🇳🇫',
    '🇲🇵',
    '🇰🇵',
    '🇳🇴',
    '🇴🇲',
    '🇵🇰',
    '🇵🇼',
    '🇵🇸',
    '🇵🇦',
    '🇵🇬',
    '🇵🇾',
    '🇵🇪',
    '🇵🇭',
    '🇵🇳',
    '🇵🇱',
    '🇵🇹',
    '🇵🇷',
    '🇶🇦',
    '🇷🇪',
    '🇷🇴',
    '🇷🇺',
    '🇷🇼',
    '🇧🇱',
    '🇸🇭',
    '🇰🇳',
    '🇱🇨',
    '🇵🇲',
    '🇻🇨',
    '🇼🇸',
    '🇸🇲',
    '🇸🇹',
    '🇸🇦',
    '🇸🇳',
    '🇷🇸',
    '🇸🇨',
    '🇸🇱',
    '🇸🇬',
    '🇸🇽',
    '🇸🇰',
    '🇸🇮',
    '🇸🇧',
    '🇸🇴',
    '🇿🇦',
    '🇬🇸',
    '🇰🇷',
    '🇸🇸',
    '🇪🇸',
    '🇱🇰',
    '🇸🇩',
    '🇸🇷',
    '🇸🇿',
    '🇸🇪',
    '🇨🇭',
    '🇸🇾',
    '🇹🇼',
    '🇹🇯',
    '🇹🇿',
    '🇹🇭',
    '🇹🇱',
    '🇹🇬',
    '🇹🇰',
    '🇹🇴',
    '🇹🇹',
    '🇹🇳',
    '🇹🇷',
    '🇹🇲',
    '🇹🇨',
    '🇹🇻',
    '🇺🇬',
    '🇺🇦',
    '🇦🇪',
    '🇬🇧',
    '🇺🇸',
    '🇻🇮',
    '🇺🇾',
    '🇺🇿',
    '🇻🇺',
    '🇻🇦',
    '🇻🇪',
    '🇻🇳',
    '🇼🇫',
    '🇪🇭',
    '🇾🇪',
    '🇿🇲',
    '🇿🇼',
  ],
};

export default emoji;
